//Inicio de la app que recibe el consumo de los servicios
//Despliega los menu para redireccion de los servicios

import React, { useEffect, useState } from "react";
import calendar from "../assets/svg/pagos.svg";
import soporte from "../assets/Icono.png";
import medios from "../assets/banner nuevos/banner-bruno2.jpg";
import report from "../assets/reportes-blanco v3.svg";
import servicios from "../assets/servicios-blanco v3.svg";
import favturas from "../assets/facturas2 blanco.svg";
import { UseContextApp } from "../Global/Context/appContext";
import { Link } from "react-router-dom";
import ConsumoController from "../controllers/ConsumoController";
import AuthController from "../controllers/AuthController";
import "./Error/Error.css";
import { colors } from "../propsType/Colors";
const services = [
  {
    name: "Servicios",
    icon: servicios,
    href: "/cuenta/servicio-de-internet",
  },
  {
    name: "Pagos",
    icon: calendar,
    href: "/cuenta/saldo",
  },
  {
    name: "Facturas",
    icon: favturas,
    href: "/cuenta/ver-facturas",
  },
  {
    name: "Reportes",
    icon: report,
    href: "/cuenta/ver-reportes",
  },
];
const Home = () => {
  const [{ user, consumoData }] = UseContextApp();
  const [loading, setLoading] = useState();
  const { consumo } = ConsumoController();
  const getConsumo = async () => {
    if (!consumoData) {
      setLoading(true);
      const res = await consumo(user);
      
      if (res) {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
  }, [consumoData]);

 return (
    <>
      <div className=" pb-12 !pt-0 lg:p-[25px]  relative bg-[#f3f4f6]  z-[-1] w-full">
        <div className="max-w-7xl grid mx-auto pt-7 px-4 sm:px-6">
          <>
            <div className="rounded-lg bg-white overflow-hidden shadow mb-6">
              <h2 className="sr-only" id="profile-overview-title">
                Profile Overview
              </h2>
              <div className="bg-[#09101F] p-6">
                <div className="sm:flex sm:items-center sm:justify-between">
                  <div className="sm:flex sm:space-x-5">
                    <div className="flex-shrink-0">
                      <div className="mx-auto border-[#ffffff52] shadow-lg flex border-2 justify-center items-center bg-white border-black  h-20 w-20 rounded-full">
                        <div>
                          <span
                            className={`font-medium text-2xl text-[${colors.lightBlue}] `}
                          >
                            {" "}
                            {user?.initial || "NA"}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left">
                      <p className="text-sm font-medium text-white">
                        Bienvenido/a{" "}
                      </p>
                      <p className="text-xl font-bold text-white sm:text-2xl">
                        {" "}
                        {user?.datos?.nombreApellido}{" "}
                      </p>
                      <p className="text-sm font-medium text-white">
                        {user?.datos?.tipoCliente}{" "}
                      </p>
                    </div>
                  </div>
                  <div className="mt-5 flex justify-center sm:mt-0">
                    <Link
                      to={"/cuenta/perfil"}
                      className="flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    >
                      Ver perfil
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg bg-white overflow-hidden shadow mb-6">
              <div className="border-t border-gray-200 bg-gray-50 grid  divide-y divide-gray-200 ">
                <div className="bg-white">
                  <div className="max-w-7xl flex flex-col gap-5 mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                    <h2
                      className={`text-3xl font-extrabold tracking-tight text-[${colors.darkBlue}] sm:text-4xl`}
                    >
                      <span className="text-[33px] font-bold text-gray-900 sm:text-2xl">
                        ¿Qué tipo de consulta deseas realizar?
                      </span>
                    </h2>
                    <p
                      className={` mt-4 text-lg leading-6 text-[${colors.darkBlue}] `}
                    >
                      Accede a las diferentes opciones para consultar y
                      autogestionar tus servicios
                    </p>
                    <div className="space-y-8 lg:py-6 sm:space-y-12">
                      <ul
                        role="list"
                        className="mx-auto grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-4 md:gap-x-6   xl:grid-cols-4"
                      >
                        {services.map((person) => (
                          <li
                            key={person.name}
                            className="hover:-translate-y-4 duration-300 hover:shadow-lg ease-in-out"
                          >
                            <Link to={person.href}>
                              <div className="space-y-4 flex flex-col justify-center rounded-xl items-center py-8 px-8 bg-gray-50">
                                <div
                                  className={`shadow-style border-[${colors.darkBlue}] border-[2px] w-[120px] h-[120px] bg-[${colors.darkBlue}] rounded-full flex justify-center items-center `}
                                >
                                  <img
                                    src={person.icon}
                                    alt=""
                                    className={`flex-shrink-0 h-14 w-14 text-[${colors.lightBlue}] `}
                                  />
                                </div>

                                <div className="space-y-2">
                                  <div className="text-xs font-medium lg:text-lg">
                                    <h3>{person.name}</h3>
                                    <p className={`text-[${colors.lightBlue}]`}>
                                      {person.role}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img className="w-full h-full rounded-t-lg" src={medios} alt="" />
            <div className="bg-white rounded-b-lg  shadow">
              <h2 className="sr-only">Texto Referencial</h2>
              <div className="max-w-7xl mx-auto divide-y divide-gray-200 lg:py-8 lg:flex lg:justify-center lg:divide-y-0 lg:divide-x">
                <div className="py-8 lg:py-0 lg:w-1/3 lg:flex-none">
                  <div className="max-w-xs mx-auto px-4 flex items-center lg:max-w-none lg:px-8">
                  <img src={soporte} alt=""  />
                    <div className="ml-4 flex-auto flex flex-col-reverse">
                      <h3 className="font-medium text-gray-900">24/7</h3>
                      <p className="text-sm text-gray-500">Soporte</p>
                    </div>
                  </div>
                </div>
                <div className="py-8 lg:py-0 lg:w-1/3 lg:flex-none">
                  <div className="max-w-xs mx-auto px-4 flex items-center lg:max-w-none lg:px-8">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`flex-shrink-0 h-8 w-8 text-[${colors.lightBlue}]`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        vectorEffect="non-scaling-stroke"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <div className="ml-4 flex-auto flex flex-col-reverse">
                      <h3 className="font-medium text-gray-900">
                        Personalizada
                      </h3>
                      <p className="text-sm text-gray-500">Atención</p>
                    </div>
                  </div>
                </div>
                <div className="py-8 lg:py-0 lg:w-1/3 lg:flex-none">
                  <div className="max-w-xs mx-auto px-4 flex items-center lg:max-w-none lg:px-8">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-8 w-8"
                      fill="#fff"
                      viewBox="0 0 24 24"
                      stroke="#5AB9E5"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        stroke-linejoin="round"
                        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                      />
                    </svg>
                    <div className="ml-4 flex-auto flex flex-col-reverse">
                      <h3 className="font-medium text-gray-900">Inmediata</h3>
                      <p className="text-sm text-gray-500">Comunicación</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default Home;
